<template>
  <div>
    <v-autocomplete
      hide-details
      :value="value"
      clearable
      :items="machineTypeList"
      dense
      flat
      filled
      placeholder="Machine Type"

      item-color="cyan"
      color="cyan"
      solo
      item-text="name"
      item-value="name"
      :loading="isLoading || loading"
      :disabled="isLoading || disabled"
      :menu-props="{
        contentClass: isLoading ? 'autocomplete-dropdown-menu is-loading' : '',
      }"
      v-bind="$attrs"
      @change="selectMachineType"
      @click:clear="$emit('click:clear'), value = null; getMachineTypes();"
      @keyup.enter="doSearch"
      :search-input.sync="searchInput"
      :filter="filterMachineTypes"
    >
      <template v-slot:no-data>
        <v-list-item>
          <div
            v-if="isLoading"
            class="w-100 d-flex align-center justify-center py-2"
          >
            <v-progress-circular indeterminate color="cyan" />
          </div>
          <v-list-item-title v-else v-html="'No Machine Type Found.'" />
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16 max-content-width"
            >{{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";

export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  name: "equipment-dropdown",
  data() {
    return {
      isLoading: false,
      machineTypeList: [],
      timeout: null,
      searchInput: "",
      timeoutLimit: 1000,
    };
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
     disabled: {
       type: Boolean,
      default: false,
    },
     loading: {
      type: Boolean,
      default: false,
    },
  
  },
  watch: {
    searchInput() {
      this.doTypingSearch();
    },
  },
  methods: {
    doTypingSearch() {
      this.isLoading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.doSearch();
      }, this.timeoutLimit);
    },
    filterMachineTypes(item, queryText) {
      const itemText = `${item?.name ?? ""}`;
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    doSearch() {
      const param = this.searchInput || "";
      if (param.length < 3) {
        this.isLoading = false;
        return;
      }
      const selectedMachineType = this.machineTypeList.find(
        (row) => row.name === this.value
      );
      if (selectedMachineType?.name && selectedMachineType.name === param) {
        this.isLoading = false;
        return;
      }
      this.getMachineTypes(param);
    },
    selectMachineType(value) {
      this.searchInput = "";
      this.$nextTick(() => {
        this.$emit("input", value);
        this.$emit("change", value);
        const valObj = this.machineTypeList.find((row) => row.id === value);
        this.$emit("change:object", valObj);
      });
    },
    getMachineTypes(search = "") {
      if (
        this.machineTypeList.length &&
        !search
      ) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "machine-type-list",
          data: {
            search,
            value: this.value,
          },
        })
        .then(({ data }) => {
          this.machineTypeList = data;
        })
        .catch((error) => {
          this.$emit("error", error.message || "Failed to load machine");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (!this.value || !this.machineTypeList.length) {
      this.getMachineTypes();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>
